import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ISimApnModel } from '@apps-common/types/management/sim-apn'

export const updateSimApn = async (model: ISimApnModel): Promise<ISimApnModel> =>
  axios.post(`/management/simapn/updatesimapn`, model).then((res) => res?.data?.data)

type Props = {
  model: ISimApnModel
}

export const useManagementUpdateSimApn = (notify?: boolean, onSuccess?: (data: ISimApnModel) => void) =>
  useMutation({
    mutationKey: ['updateSimApn'],
    mutationFn: ({ model }: Props) => updateSimApn(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated sim apn.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update sim apn, please try again.')
      }
    },
    throwOnError: false
  })
